<template>
    <div>
        <v-toolbar flat fixed>
            <v-toolbar-title>{{ $t('userType.toolbarTitle') }}</v-toolbar-title>
        </v-toolbar>

        <div class="hastoolbar hasfooter">

            <v-alert color="info" dense :value="true" style="background-color:#edf0f7 !important;font-size:12px">{{ $t('userType.changeLater') }}</v-alert>
            <v-card class="ma-4">
                <v-list two-line nopadding>
                  <v-list-item @click="fn_changeUserType(1)">
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('userType.businessOwner') }}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-icon color="primary">{{userType == 1 ? 'radio_button_checked' : 'radio_button_unchecked'}}</v-icon>
                      <!-- <img src="../../assets/icon_done.svg" style="width:24px"/> -->
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="fn_changeUserType(2)">
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('userType.accountant') }}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-icon color="primary">{{userType == 2 ? 'radio_button_checked' : 'radio_button_unchecked'}}</v-icon>
                      <!-- <img src="../../assets/icon_done.svg" style="width:24px"/> -->
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
            </v-card>
            
        </div>
        

        <v-footer fixed :height="64">
            <!-- <v-layout row wrap ma-0>
                <v-flex xs4 sm4 md4>
                    <v-btn text color="primary" v-if="userType===2" large @click="isSkip=true">Skip</v-btn>
                </v-flex>

                <v-flex xs8 sm8 md8 right-align>
                    <v-btn color="primary" large @click="fn_getToken('register')">Register Business</v-btn>
                </v-flex>
            </v-layout> -->

            <v-layout row wrap ma-0>
                <v-flex xs12 sm12 md12 right-align>
                    <!-- <v-btn color="primary" large block @click="fn_openDialogConfirmation">Save</v-btn> -->
                    <v-btn color="primary" large block @click="fn_getToken">{{ $t('userType.saveBtn') }}</v-btn>
                </v-flex>
            </v-layout>
        </v-footer>

        <dialog-confirmation ref="ref_dialogConfirmation" :header="header" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod"></dialog-confirmation>
    </div>
</template>

<script>

import dialogConfirmation from '../dialogs/dialog_confirmation'

    export default{
        data(){
            return{
                userType:1,
                header:null,
                confirmationMessage:null,
                actionMethod:null,
                confirmExit:false
            }
        },

        components:{
            'dialog-confirmation':dialogConfirmation
        },

        methods:{

            fn_goBack: function(){
                this.$router.go(-1);
            },

            fn_openDialogConfirmation: function(type){
                if(type=='exit'){
                    this.header = this.$t('userType.quitRegistrationHeader');
                    this.confirmationMessage = null;
                    this.actionMethod = this.fn_confirmExit;
                }
                // else{
                //     this.header = this.userType == 1 ? 'Business Owner' : 'Accountant';
                //     this.confirmationMessage = this.userType == 1 ? 'Register as a Business Owner' : 'Register as an Accountant';
                //     this.actionMethod = this.fn_getToken;
                // }
                this.$refs['ref_dialogConfirmation'].openDialogWeb();
            },

            fn_confirmExit: function(){
                this.confirmExit = true;
                this.fn_closeDialog();
                this.fn_goBack();
            },

            fn_closeDialog: function(){
              this.$refs['ref_dialogConfirmation'].closeDialogWeb();
            },

            fn_changeUserType: function(val){
                this.userType = val; 
                let msg = val == 1 ? this.$t('userType.registerAsBusinessOwner') : this.$t('userType.registerAsAccountant');
                this.showToast(msg);
            },

            fn_newBusiness: function(){
                this.confirmExit = true;
                this.$router.push({path:'/registration/business/register', query:{"mobile_number":this.$route.query.mobile_number, 'user_name':this.$route.query.user_name, 'usertype':this.userType}});
            },

            fn_getToken: function(){
                this.fn_closeDialog();
                this.showLoading(this.$t('userType.settingUpUserType'));
                this.$root.fn_getAuthToken(token=>{
                    if(token == 'error'){
                        this.hideLoading();
                    }
                    else{
                        this.fn_setUserType(token);
                    }
                })
            },

            fn_setUserType: function(token){
                if(!navigator.onLine){
                    this.showToast(this.$t('userType.internetNotAvailableNoExcl'));
                    this.hideLoading();
                    return;
                }
                
                let self = this;
                let dataObj = {};
                dataObj.token = token;
                dataObj.usertype = this.userType;
                this.getServerData('SetUserType', dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.hideLoading();
                            self.fn_newBusiness();
                            // if(type=="register"){
                            //     self.hideLoading();
                            //     self.fn_newBusiness();
                            // }
                            // else{
                            //     self.fn_setUserName(token);
                            // }
                            
                            // self.hideLoading();
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            if(typeof JSON.parse(error) == 'object'){
                                let response = JSON.parse(error);
                                self.showToast(response.Message);
                            }
                        }, 
                    }
                );
            },

            // fn_setUserName: function(token){
            //     if(!navigator.onLine){
            //         this.showToast('Internet not available');
            //         return;
            //     }
                
            //     let self = this;
            //     let dataObj = {};
            //     dataObj.token = token;
            //     dataObj.Name = this.userName;
            //     this.getServerData('SetUserName', dataObj, 
            //         {
            //             onSuccess: function(response){
            //                 console.log(response);
            //                 self.hideLoading();
            //             }, 
            //             onError: function(error){
            //                 console.log(error);
            //                 self.hideLoading();
            //                 if(typeof JSON.parse(error) == 'object'){
            //                     let response = JSON.parse(error);
            //                     self.showToast(response.Message);
            //                 }
            //             }, 
            //         }
            //     );
            // },
        },

        mounted: function(){
            // this.userName = this.$route.query.userName;
            window.js_globals.fn_onBackPress = this.fn_goBack;
        },

        beforeRouteLeave (to, from, next) {
            if(this.$refs['ref_dialogConfirmation'].dialog_confimation){
                this.fn_closeDialog();
                next(false);
            }
            else if(!this.confirmExit){
                this.fn_openDialogConfirmation('exit');
                next(false);
            }
            else{
                next();
            }
        }
    }
</script>